import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {connect} from 'react-redux';
import isEmpty from "lodash/isEmpty";
import Preloader from "../Components/Preloader";
import {shopsClearData, startInitiallyLoadingShops} from "../actions/Shops";
import {getMe} from "../thunks/Auth";
import {getQueryParams} from "./utils";


const PrivateRouteWithShops = (
  {
    component: Component,
    activeShop,
    isAuthenticated,
    redirectReport,
    authToken,
    shopsAreInitiallyLoaded,
    shopsClearData,
    startInitiallyLoadingShops,
    getMe,
    shops,
    ...rest
  }
) => (
  <Route
    {...rest}
    render={props => {
      const queryAuthToken = new URL(window.location.href).searchParams.get('authToken');
      const activeShopParam = new URL(window.location.href).searchParams.get('activeShopParam');
      if(activeShopParam){
        localStorage.setItem('activeShop',activeShopParam);
      }
      if (!isEmpty(queryAuthToken) && (!isAuthenticated || authToken !== queryAuthToken)) {
        getMe(queryAuthToken);
        return (<Preloader/>)
      }



      if ((!shopsAreInitiallyLoaded || !activeShop || !shops?.length) && redirectReport && props.location.pathname.indexOf('auth/report') === -1) {
        return (<Redirect replace to='/auth/report'/>);
      }

      if (!isAuthenticated) {
        if (shopsAreInitiallyLoaded || activeShop) {
          // shopsClearData();
          return (<Preloader/>)
        }
      }
      if (isAuthenticated) {
        if (!shopsAreInitiallyLoaded || !activeShop) {
          startInitiallyLoadingShops();
          return (<Preloader/>)
        }
      }

      const path = props.location.pathname;
      const pathShopId = parseInt(path.match(/^\/(\d+)\//)?.[1]);

      // if (!isAuthenticated) {
      //   return (<Redirect to='/auth/login'/>);
      // }

      if (pathShopId && pathShopId !== activeShop.id) {
        const redirectPath = path.replace(/^\/(\d+)\//, `/${activeShop.id}/`);
        return (<Redirect to={redirectPath}/>);
      }

      return (<Component {...props} />)
    }}
  />
);

const mapStateToProps = state => ({
  isAuthenticated: state.Auth.isAuthenticated,
  activeShop: state.Shops.activeShop,
  authToken: state.Auth.authToken,
  shopsAreInitiallyLoaded: state.Shops.shopsAreInitiallyLoaded,
  shops: state.Shops.shops,
  redirectReport: state.Auth.redirectReport,
});

const mapDispatchToProps = dispatch => ({
  shopsClearData: () => dispatch(shopsClearData()),
  startInitiallyLoadingShops: () => dispatch(startInitiallyLoadingShops()),
  getMe: (authToken) => dispatch(getMe(authToken)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRouteWithShops);
